import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

const Services: React.FC = () => {
  return (
    <Container maxWidth="md" style={{ marginTop: '50px', marginBottom: '80px', fontFamily: 'Roboto, sans-serif', padding: '20px' }}>
      <Typography variant="h4" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
        Future-Ready Development &amp; Technology Solutions
      </Typography>
      <Typography variant="body1" style={{ color: '#555', marginBottom: '40px', lineHeight: 1.8 }}>
        At DH Technologies, we bridge the gap between traditional property development and the high-tech demands of tomorrow.
        Our team provides expert guidance and end-to-end management for projects that require both structural integrity and
        cutting-edge innovation.
      </Typography>

      <Divider style={{ marginBottom: '40px' }} />

      <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '32px' }}>
        Our Core Services
      </Typography>

      {/* Service 1 */}
      <Box style={{ marginBottom: '40px' }}>
        <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '12px' }}>
          1. Strategic Consultation
        </Typography>
        <Typography variant="body1" style={{ color: '#555', marginBottom: '12px', lineHeight: 1.8 }}>
          We offer specialized advisory services to help you navigate the complexities of modern infrastructure and digital transformation:
        </Typography>
        <ul style={{ color: '#555', lineHeight: 2, paddingLeft: '24px' }}>
          <li><strong>Renewable Energy:</strong> Feasibility and integration of solar, wind, and microgrid solutions.</li>
          <li><strong>Battery Technology:</strong> Advice on BESS (Battery Energy Storage Systems) for residential, commercial, or industrial applications.</li>
          <li><strong>AI &amp; Emerging Tech:</strong> Consulting on how to leverage Artificial Intelligence and smart-building automation to increase asset value.</li>
          <li><strong>Technology Integration:</strong> Strategic planning for future-proofing developments with high-speed connectivity and IoT ecosystems.</li>
        </ul>
      </Box>

      {/* Service 2 */}
      <Box style={{ marginBottom: '40px' }}>
        <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '12px' }}>
          2. End-to-End Property Development
        </Typography>
        <Typography variant="body1" style={{ color: '#555', marginBottom: '12px', lineHeight: 1.8 }}>
          We take your vision from a conceptual sketch to a shovel-ready project. Our team manages the critical regulatory "bridge" that defines every successful build:
        </Typography>
        <ul style={{ color: '#555', lineHeight: 2, paddingLeft: '24px' }}>
          <li>
            <strong>DA (Development Application):</strong> We handle the planning phase, ensuring your project meets local council zoning,
            environmental, and community standards to secure your permit.
          </li>
          <li>
            <strong>BA (Building Approval):</strong> Once the DA is set, we manage the technical construction documentation, structural engineering,
            and compliance checks required for your final building permit.
          </li>
        </ul>
      </Box>

      {/* Service 3 */}
      <Box style={{ marginBottom: '56px' }}>
        <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '12px' }}>
          3. Professional Project Management
        </Typography>
        <Typography variant="body1" style={{ color: '#555', marginBottom: '12px', lineHeight: 1.8 }}>
          We act as your single point of contact, ensuring every phase of your project is executed with precision.
        </Typography>
        <ul style={{ color: '#555', lineHeight: 2, paddingLeft: '24px' }}>
          <li><strong>Full Lifecycle Oversight:</strong> Coordination of architects, engineers, energy specialists, and contractors.</li>
          <li><strong>Compliance &amp; Quality:</strong> Ensuring all tech and energy integrations meet strict regulatory and safety standards.</li>
          <li><strong>Risk &amp; Budget Management:</strong> Keeping your project on track, on budget, and ready for the future.</li>
        </ul>
      </Box>

      <Divider style={{ marginBottom: '40px' }} />

      {/* Why Choose Us */}
      <Box
        style={{
          backgroundColor: '#f5f7fa',
          borderLeft: '4px solid #1a237e',
          padding: '28px 32px',
          borderRadius: '8px',
        }}
      >
        <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
          Why Choose Us?
        </Typography>
        <Typography
          variant="h6"
          style={{ fontStyle: 'italic', color: '#1a237e', marginBottom: '16px', fontWeight: 500 }}
        >
          "We don't just build for today; we engineer for the next decade."
        </Typography>
        <Typography variant="body1" style={{ color: '#555', lineHeight: 1.8 }}>
          In a world where technology moves faster than brick and mortar, you need a partner who understands both. We combine
          decades of property experience with a deep mastery of the renewable and digital sectors to deliver assets that are
          efficient, sustainable, and intelligent.
        </Typography>
      </Box>
    </Container>
  );
};

export default Services;
